<template>
  <div class="">
    <div>
      <el-button type="primary" @click="addCtiy">添加</el-button>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="value"
            label="编号">
          </el-table-column>
          <el-table-column
            prop="name"
            label="分类">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="前端展示">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1">展示</span>
              <span v-else>不展示</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="editorCity(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="changeStatus(scope.row, 1)" type="text" size="small" v-if="scope.row.status === 0">展示</el-button>
                <el-button @click="changeStatus(scope.row, 0)" type="text" size="small" style="color: red;" v-else>不展示</el-button>
                <el-button @click="upDownMove(scope.row.id,scope.$index - 1)" type="text" size="small" v-if="scope.$index>0">上移</el-button>
                <el-button @click="upDownMove(scope.row.id,scope.$index + 1)" type="text" size="small" v-if="scope.$index < tableData.length-1">下移</el-button>
                <el-button @click="upDownMove(scope.row.id,0, true)" type="text" size="small" >置顶</el-button>
                <el-button @click="upDownMove(scope.row.id,-1, true)" type="text" size="small" >置底</el-button>
                <el-button @click="deleteLinkage(scope.row.id)" type="text" size="small" style="color: gray;">删除</el-button> 
              </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog :title="dlgType === 'change' ? '编辑分类' : '新建分类'" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px;">
        <div>
          <el-form ref="editClassForm" :model="editClassForm" :rules="editorFormRules" label-width="120px">
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input clearable v-model="editClassForm.value" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="分类名称" prop="name">
              <el-input clearable v-model="editClassForm.name"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditorCityDlg">暂不</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {

      // 表格数据
      tableTotal: 0,
      tableData: [],
      typeKey: 'category',
      pageSize: 10,
      currentPage: 1,


      // 新建编辑对话框数据

      isDlg: false,
      editClassForm: {
        id: null,
        value: null,
        name: '',
        typeKey: 'category',
        parentId: null,
      },

      editorFormRules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'change' },
        ]
      },


      dlgType: 'change',
      loading: false,
    }
  },
  watch:{},
  computed:{},
  methods:{
    deleteLinkage(id){
      let self = this
        self.$confirm('是否删除').then(() => {
              self.$api.deleteLinkage({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getClassList()
          }
      })
      })

    },
      // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },
    handleCurrentChange(val) {
      this.currentPage = val

      // 重新请求订单数据
      this.getClassList()
    }, 

    // 获取订单数据
    getClassList() {
      let self  = this;
      self.$api.getClass({
        typeKey: self.typeKey,
        page: self.currentPage,
        size: self.pageSize
      }).then(res => {

        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 添加城市经理
    addCtiy() {
      this.dlgType = 'new'
      this.editClassForm=this.$options.data().editClassForm;
      this.$nextTick(()=>{
          this.$refs['editClassForm'].clearValidate()
      })
      this.isDlg = true
    },

    // 修改城市经理
    editorCity(row) {
      let self = this;
      self.editClassForm = {
        id: null,
        value: null,
        name: '',
        typeKey: 'category',
        parentId: null,
      },

      self.dlgType = 'change'

      for(let i in self.editClassForm) {
        if(row[i]) self.editClassForm[i] = row[i]
      }

      self.isDlg = true
    },

    // 关闭编辑对话框
    closeEditorCityDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs['editClassForm'].validate((valid) => {
        if (valid) {
          let params = {}
          for(let i in self.editClassForm) {
            params[i] = this.editClassForm[i]
          }
          if(self.dlgType === 'change') {
            self.$api.changeLinkage(params.id, params).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getClassList()
                this.closeEditorCityDlg()
              }
            })
          } else {
            self.$api.addLinkage(params).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.getClassList()
                this.closeEditorCityDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     
    },

    changeStatus(row, newStatus) {
      let self = this
      self.$api.changeLinkage(row.id, {
        name: row.name,
        status: newStatus,
        typeKey: 'category',
      }).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.getClassList()
        }
      })
    },
    upDownMove(id, toIndex, type) {
      let self = this;
      self.$api.changeLinkageOrder({
        currentId: id,
        swapId: type ? toIndex: self.tableData[toIndex].id
      }).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '移动成功',
            type: 'success'
          });
          self.getClassList()
        }
      })
    }


  },
  created(){},
  mounted(){
    let self = this;
    self.getClassList()
  }
}
</script>
<style lang="less" scoped>
</style>